import React from 'react'
import {
  // Center,
  Flex,
  Heading,
  // Tabs,
  // TabList,
  // Tab,
} from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks'
import { useSelector } from 'react-redux'

interface Iprops {
  type: any
  setType: any
  userStateData: any
  timeComponent?: any
}

const TrainingModuleHeader = (props: Iprops) => {
  // const { userStateData } = props;

  // const timeRequired = 3600000 * 36;

  // const timeDiff =
  //   Date.now() -
  //   userStateData?.state_details[0]?.data.pan_verification_timestamp;

  // const timeRemaining =
  //   timeDiff >= timeRequired
  //     ? 0
  //     : Math.round((timeRequired - timeDiff) / (1000 * 60 * 60));
  const { isMobile } = useDeviceType()
  const { journeyType } = useSelector((state: any) => state.user)
  return (
    <>
      <Flex
        justifyContent='space-between'
        px={isMobile ? 6 : 10}
        py={isMobile ? '4' : '5'}
        alignItems='center'
      >
        <Heading fontWeight='bold' size={isMobile ? 'sm' : 'md'}>
          {journeyType === 'LIFE' ? 'Life' : 'General'} Insurance Training Module
        </Heading>
        {/* <Flex flexDirection="column" alignItems="flex-end">
          <Heading color="#366B9E" size="sm">
            {36} hrs left
          </Heading>
          <Text fontSize="sm">Before you can appear in the exam</Text>
        </Flex> */}
        {props.timeComponent}
      </Flex>
      {/* <Center mt={4}>
        <Flex gap="5" alignItems="center">
          <Tabs color="grey">
            <TabList borderBottom={type === 'single' ? 'blue.100' : ''}>
              <Tab
                bg={type === 'life' ? 'blue.100 ' : ''}
                //   borderBottom=
                fontWeight={type === 'life' ? '700' : ''}
                onClick={() => {
                  setType('life');
                }}
              >
                Life Insurance
              </Tab>

              <Tab
                bg={type === 'life' ? 'blue.100 ' : ''}
                fontWeight={type === 'life' ? ' 700' : ''}
                onClick={() => {
                  setType('life');
                }}
              >
                Life Insurance
              </Tab>
            </TabList>
          </Tabs>
        </Flex>
      </Center> */}
    </>
  )
}

export default TrainingModuleHeader
